import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { useStickersSettingsPopupPresenter } from 'APP/main/PopupManager/Popups/StickersSettingsPopup/StickersSettingsPopup.presenter';

import { StickersSettingsContent } from './StickersSettingsContent/StickersSettingsContent';

export const StickersSettingsPopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useStickersSettingsPopupPresenter(props);

  return (
    <Popup
      title={t('settings')}
      isOpened
      isHidden={props.popupInstance.isHidden}
      onClose={presenter.onClose}
    >
      <StickersSettingsContent onStickerPackClick={presenter.openStickerPackPopup} />
    </Popup>
  );
});
